export default __webpack_public_path__ + "static/media/ava.41b85ec1.png";